module.exports = __webpack_public_path__ + "static/img/xj1230.1aefd67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj1230.jpg
// module id = LDda
// module chunks = 0